import {useEffect} from 'react';
import {useEditBenefactorEmailForm} from '../../model';
import {ActionModal, FormInput, useErrorHandler, ErrorModal} from '../../../../shared';
import {useParams} from 'react-router';
import {BenefactorModel} from '../../../../entities';

interface EditBenefactorEmailModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  benefactor?: BenefactorModel;
}

export const EditBenefactorEmailModal = ({open, setOpen, benefactor}: EditBenefactorEmailModalProps) => {
  const params = useParams();

  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditBenefactorEmailForm({setOpen, benefactorId: params.id ?? '', benefactor});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Email пользователя',
    title: 'Ошибка при обновлении email',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Изменить'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Email"
          placeholder="example@mail.com"
          name="email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.email && errors.email}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
